import React from 'react';

const CustomScrollBar = (props: React.HTMLAttributes<unknown>) => {
    return <div {...props} style={{ ...props.style, right: 2, bottom: 2, top: 2, borderRadius: 3, zIndex: 5 }} />;
};

export default CustomScrollBar;
